import { Table } from "@/pages/a7/Table";

import { type A7OPCVMIssuer, getIssuersColumns } from "./columns";
import { FilterA7OPCVMIssuers, filterA7OPCVMIssuersSchema } from "./filter";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

const table_name = "a7_opcvm_issuers";

export const A7OPCVMIssuersTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(() => getIssuersColumns(t), [t, i18n.language]);
  const columnVisibilityInit = {
    contact_fonds: false,
    contact_afd: false,
    business_manager: false,
  };

  return (
    <Table<A7OPCVMIssuer, typeof filterA7OPCVMIssuersSchema>
      label={t(`${table_name}.title`, { defaultValue: "Issuers" })}
      table_name={table_name}
      columns={columns}
      filter={<FilterA7OPCVMIssuers />}
      columnVisibilityInit={columnVisibilityInit}
      client="a7"
    />
  );
};
